import { useEffect, useState } from "react";
import Select from "react-select";
import swal from "sweetalert";
import {
    PropertyMappingDelete,
    getBasicPropertydetails,
    ReservationMealplan,
    ReservationRateCodeList,
    ReservationMAppingList,
    ResRoomlist,
} from "../../../Services/Service";
import ReservationSidebar from "../../Commun/ReservationSidebar";
import ReservationHeader from "../../Commun/ReservationHeader";
import { useProperty } from "../../../PropertyContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { AddRateInventory } from "./AddRateInventory";
import '../PropertyDetails.css';
import { EditRateInventory } from "./EditRateInventory";

export const ReservationRateInventory = () => {
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);
    const [mappingLoading, setMappingLoading] = useState(false);
    const [mappinglist, setMappingList] = useState([]);
    const [ratecode, setRatecode] = useState([]);
    const [mealplan, setMealplan] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [Pms, setPMS] = useState();

    // Filter states (only for main page filter form)
    const [filterRate, setFilterRate] = useState("");
    const [filterRoom, setFilterRoom] = useState("");
    const [filterMealPlan, setFilterMealPlan] = useState("");
    const [filterFrom, setFilterFrom] = useState("");
    const [filterTo, setFilterTo] = useState("");

    // Edit row data passed to modal
    const [editData, setEditData] = useState(null); // null = Add mode, object = Edit mode

    // ─── Fetch PMS ───────────────────────────────────────────
    useEffect(() => {
        const FetchPMS = async () => {
            try {
                const result = await getBasicPropertydetails();
                if (result && result.length > 0) setPMS(result[0]);
            } catch (error) {
                console.log("error fetch Pms", error);
            }
        };
        FetchPMS();
    }, []);

    // ─── Fetch Rate Codes ─────────────────────────────────────
    useEffect(() => {
        const FetchRatecode = async () => {
            setLoading(true);
            try {
                const result = await ReservationRateCodeList(selectedProperty?.PropertyID);
                if (Array.isArray(result)) {
                    setRatecode(result);
                    const firstRateCodeId = result.length > 0 ? result[0].RateCodeID : 0;
                    fetchMappingList(firstRateCodeId);
                } else {
                    fetchMappingList(0);
                }
            } catch (error) {
                console.log("error get rate code", error);
                fetchMappingList(0);
            } finally {
                setLoading(false);
            }
        };
        FetchRatecode();
    }, [selectedProperty]);

    // ─── Fetch Meal Plans ─────────────────────────────────────
    useEffect(() => {
        const FetchMealplan = async () => {
            setLoading(true);
            try {
                const result = await ReservationMealplan(selectedProperty?.PropertyID);
                if (Array.isArray(result)) setMealplan(result);
            } catch (error) {
                console.log("error get meal plan", error);
            } finally {
                setLoading(false);
            }
        };
        FetchMealplan();
    }, [selectedProperty]);

    // ─── Fetch Rooms ──────────────────────────────────────────
    useEffect(() => {
        const fetchRoomData = async () => {
            setLoading(true);
            try {
                const data = await ResRoomlist(selectedProperty?.PropertyID);
                if (data && Array.isArray(data.RoomsDetails)) {
                    setRooms(data.RoomsDetails);
                } else {
                    setRooms([]);
                }
            } catch (error) {
                console.error("Room data fetch error:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRoomData();
    }, [selectedProperty]);

    // ─── Mapping List ─────────────────────────────────────────
    const fetchMappingList = async (rateCodeId) => {
        setMappingLoading(true);
        try {
            const result = await ReservationMAppingList(rateCodeId, selectedProperty?.PropertyID);
            if (Array.isArray(result)) setMappingList(result);
            else setMappingList([]);
        } catch (error) {
            console.log("Error fetching mapping list", error);
            setMappingList([]);
        } finally {
            setMappingLoading(false);
        }
    };

    useEffect(() => {
        setFilteredList(mappinglist);
    }, [mappinglist]);

    // ─── After Save: refresh mapping list ────────────────────
    const handleAfterSave = async () => {
        const result = await ReservationMAppingList(1, selectedProperty?.PropertyID);
        if (Array.isArray(result)) setMappingList(result);
    };

    // ─── Add Button ───────────────────────────────────────────
    const handleAdd = () => {
        setEditData(null); // null = Add mode
    };

    // ─── Edit Button ──────────────────────────────────────────
    const handleEdit = (item) => {
        setEditData(item); // pass full row data to modal
    };

    // ─── Delete ───────────────────────────────────────────────
    const handleDelete = async (RateCodeMealPlanID) => {
        setLoading(true);
        try {
            const confirm = await swal({
                title: "Are you sure?",
                icon: "warning",
                buttons: {
                    cancel: "Cancel",
                    confirm: {
                        text: "Delete",
                        value: true,
                        visible: true,
                        className: "btn-danger",
                        closeModal: true,
                    },
                },
                dangerMode: true,
            });

            if (confirm) {
                await PropertyMappingDelete(RateCodeMealPlanID);
                setMappingList((prev) =>
                    prev.filter((item) => item.RateCodeMealPlanID !== RateCodeMealPlanID)
                );
                swal("Mapping Deleted Successfully", { icon: "success" });
            }
        } catch (error) {
            console.log("error deleting mapping", error);
            swal("Failed to delete mapping!", { icon: "error" });
        } finally {
            setLoading(false);
        }
    };

    // ─── Filter ───────────────────────────────────────────────
    const formatOptions = (list, labelKey, valueKey) =>
        list.map((item) => ({ label: item[labelKey], value: item[valueKey] }));

    const handleFilter = (e) => {
        e.preventDefault();
        setLoading(true);
        let temp = mappinglist;
        if (filterRate) temp = temp.filter((item) => item.RateCodeID === Number(filterRate));
        if (filterRoom) temp = temp.filter((item) => item.RoomTypeID === Number(filterRoom));
        if (filterMealPlan) temp = temp.filter((item) => item.MealPlanID === Number(filterMealPlan));
        if (filterFrom) temp = temp.filter((item) => item.EffectiveFrom.split("T")[0] >= filterFrom);
        if (filterTo) temp = temp.filter((item) => item.EffectiveTo.split("T")[0] <= filterTo);
        setFilteredList(temp);
        setLoading(false);
    };

    const handleClear = () => {
        setFilterRate("");
        setFilterRoom("");
        setFilterMealPlan("");
        setFilterFrom("");
        setFilterTo("");
        setFilteredList(mappinglist);
    };

    return (
        <>
            <style>{`
                .form-control {
                    border-width: 1px !important;
                    border-color: hsl(0, 0%, 80%);
                }
            `}</style>

            {(mappingLoading || loading) && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x" role="status"></div>
                </div>
            )}

            <div className="wrapper property-details-page">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">

                            {/* ── Filter Form ─────────────────────────── */}
                            <div className="row">
                                <div className="col-md-12">
                                    <form className="mb-3" onSubmit={handleFilter}>
                                        <div className="row">
                                            {Pms?.PMS === "Opera" && (
                                                <div className="col-sm-2">
                                                    <div className="mb-3">
                                                        <label className="form-label">Rate Code</label>
                                                        <Select
                                                            options={formatOptions(ratecode, "Name", "RateCodeID")}
                                                            value={filterRate ? { label: ratecode.find((r) => r.RateCodeID === filterRate)?.Name || "", value: filterRate } : null}
                                                            onChange={(e) => setFilterRate(e ? e.value : "")}
                                                            placeholder="Select code"
                                                            isClearable
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Room Name</label>
                                                    <Select
                                                        options={formatOptions(rooms, "RoomName", "RoomID")}
                                                        value={filterRoom ? { label: rooms.find((r) => r.RoomID === filterRoom)?.RoomName || "", value: filterRoom } : null}
                                                        onChange={(e) => setFilterRoom(e ? e.value : "")}
                                                        placeholder="Select room"
                                                        isClearable
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Meal Plan</label>
                                                    <Select
                                                        options={formatOptions(mealplan, "Name", "MealPlanID")}
                                                        value={filterMealPlan ? { label: mealplan.find((m) => m.MealPlanID === filterMealPlan)?.Name || "", value: filterMealPlan } : null}
                                                        onChange={(e) => setFilterMealPlan(e ? e.value : "")}
                                                        placeholder="Select plan"
                                                        isClearable
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">From</label>
                                                    <input type="date" className="form-control" value={filterFrom} onChange={(e) => setFilterFrom(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">To</label>
                                                    <input type="date" className="form-control" value={filterTo} onChange={(e) => setFilterTo(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div style={{ marginTop: "27px" }}>
                                                    <button className="btn btn-primary me-2">Filter</button>
                                                    <button type="button" className="btn btn-danger" onClick={handleClear}>Clear</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {/* ── Table ───────────────────────────────── */}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h4 className="card-title">Rate Inventory List</h4>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#add-rate-modal"
                                                    onClick={handleAdd}
                                                >
                                                    Add
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body table-card-body">
                                            <div className="table-responsive">
                                                <DataTable
                                                    value={filteredList}
                                                    paginator
                                                    rows={10}
                                                    stripedRows
                                                    responsiveLayout="scroll"
                                                    emptyMessage="No Data Found"
                                                >
                                                    {Pms?.PMS === "Opera" && (
                                                        <Column field="RateCodeName" header="Rate Code" sortable />
                                                    )}
                                                    <Column field="RoomName" header="Room Name" sortable style={{ width: "350px" }} />
                                                    <Column field="MealPlanName" header="Meal Plan" sortable />
                                                    <Column
                                                        header="Base Rate"
                                                        body={(rowData) => `₹ ${rowData.BaseRate}`}
                                                        sortable
                                                    />
                                                    <Column
                                                        header="From"
                                                        body={(rowData) => new Date(rowData.EffectiveFrom).toLocaleDateString("en-GB")}
                                                        sortable
                                                    />
                                                    <Column
                                                        header="To"
                                                        body={(rowData) => new Date(rowData.EffectiveTo).toLocaleDateString("en-GB")}
                                                        sortable
                                                    />
                                                    <Column
                                                        header="Status"
                                                        body={(rowData) =>
                                                            rowData.IsActive ? (
                                                                <span className="badge bg-success">Active</span>
                                                            ) : (
                                                                <span className="badge bg-danger">Inactive</span>
                                                            )
                                                        }
                                                    />
                                                    <Column
                                                        header="Action"
                                                        body={(rowData) => (
                                                            <>
                                                                <Button
                                                                    icon="pi pi-pencil"
                                                                    className="p-button-sm p-button-text me-2"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#edit-rate-modal"
                                                                    onClick={() => handleEdit(rowData)}
                                                                />
                                                                <Button
                                                                    icon="pi pi-trash"
                                                                    className="p-button-sm p-button-text text-danger"
                                                                    onClick={() => handleDelete(rowData.RateCodeMealPlanID)}
                                                                />
                                                            </>
                                                        )}
                                                    />
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* ── ADD Modal ───────────────────────────────────── */}
            <div className="modal fade property-details-modal" id="add-rate-modal" tabIndex={-1} role="dialog" aria-labelledby="addRateModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addRateModalLabel">Add Rates</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <AddRateInventory
                                Pms={Pms}
                                ratecode={ratecode}
                                mealplan={mealplan}
                                rooms={rooms}
                                onSaveSuccess={handleAfterSave}
                                modalId="add-rate-modal"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* ── EDIT Modal ──────────────────────────────────── */}
            <div className="modal fade property-details-modal" id="edit-rate-modal" tabIndex={-1} role="dialog" aria-labelledby="editRateModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editRateModalLabel">Edit Rates</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <EditRateInventory
                                Pms={Pms}
                                ratecode={ratecode}
                                mealplan={mealplan}
                                rooms={rooms}
                                editData={editData}
                                onSaveSuccess={handleAfterSave}
                                modalId="edit-rate-modal"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
